import { setupPlausible } from '../../components/plausible';
const getSourcePublicationId = () => { var _a, _b; return (_b = (_a = document.querySelector('.js-publication__newsletter_thank_you')) === null || _a === void 0 ? void 0 : _a.dataset) === null || _b === void 0 ? void 0 : _b.sourcePublicationId; };
window.up.compiler('.js-skip_newsletter_recommendations', link => {
    const { trackEvent } = setupPlausible();
    const sourcePublicationId = getSourcePublicationId();
    if (link instanceof HTMLElement && sourcePublicationId) {
        link.addEventListener('click', () => {
            trackEvent('Newsletter Recommendation All Skipped', {
                props: {
                    page: 'newsletter_thank_you',
                    recommendation_source_publication_id: sourcePublicationId
                }
            });
        });
    }
});
